import { render } from "./Kennel.vue?vue&type=template&id=02005f2c"
import script from "./Kennel.vue?vue&type=script&lang=js"
export * from "./Kennel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__